
import { ACTIONS } from '_redux/actions';
import { get } from './api';

export function fetchCultures(params) {
  return get('cultures',
    params,
    ACTIONS.CULTURES.FETCH_CULTURES,
    ACTIONS.CULTURES.FETCH_CULTURES_SUCCESS,
    ACTIONS.CULTURES.FETCH_CULTURES_ERROR);
}
